export default __webpack_public_path__ + "static/media/AC_3.6a1458c5.jpg";